import React from 'react';

import { BadgeProps } from './types';
import { Component } from './styles';

export const Badge = React.forwardRef<HTMLSpanElement, BadgeProps>(
  ({ color = 'default', children }, ref) => {
    return (
      <Component ref={ref} color={color}>
        {children}
      </Component>
    );
  }
);
